import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form-wrapper" }
const _hoisted_3 = { class: "address-input" }
const _hoisted_4 = {
  key: 0,
  class: "status-area"
}
const _hoisted_5 = {
  key: 0,
  class: "status-block status-block--checking"
}
const _hoisted_6 = { class: "status-icon" }
const _hoisted_7 = { class: "status-text" }
const _hoisted_8 = {
  key: 2,
  class: "status-block status-block--info"
}
const _hoisted_9 = { class: "status-text" }
const _hoisted_10 = {
  key: 0,
  class: "status-block status-block--info"
}
const _hoisted_11 = { class: "status-text" }
const _hoisted_12 = {
  key: 2,
  class: "form-group"
}
const _hoisted_13 = {
  key: 3,
  class: "form-group"
}
const _hoisted_14 = {
  key: 0,
  class: "delivery-info delivery-info--available"
}
const _hoisted_15 = { class: "delivery-info__row" }
const _hoisted_16 = { class: "delivery-info__value" }
const _hoisted_17 = { class: "delivery-info__row" }
const _hoisted_18 = { class: "delivery-info__value" }
const _hoisted_19 = {
  key: 1,
  class: "store-info"
}
const _hoisted_20 = { class: "store-info__value" }
const _hoisted_21 = {
  key: 4,
  class: "status-area"
}
const _hoisted_22 = {
  key: 5,
  class: "d-flex align-items-center"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "submit-suggest"
}
const _hoisted_25 = { class: "map-address-clarification" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper modal-address-clarification", {
            'form--active': $setup.formActive,
        }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "placemarks-head" }, [
        _createElementVNode("div", { class: "placemarks-head__title" }, "Новый адрес доставки")
      ], -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode($setup["AutocompleteInput"], {
            placeholder: "Введите название улицы",
            label: "Улица, номер дома",
            "default-value": $setup.address.value,
            suggestions: $setup.address.suggestions,
            process: $setup.processAutocomplete,
            classes: [
                            'form-control',
                            !$setup.address.valid && $setup.address.msg ? 'is-invalid' : '',
                            $setup.address.valid ? 'is-valid' : '',
                        ],
            onHandleLazyKeyup: $setup.fetchSuggestionsAddress,
            onHandleSetSuggestion: $setup.selectSuggestionAddress,
            onHandleChange: _cache[0] || (_cache[0] = (val) => ($setup.address.value = val)),
            onHandleFocus: _cache[1] || (_cache[1] = () => ($setup.focusState = true)),
            onHandleBlur: _cache[2] || (_cache[2] = () => ($setup.focusState = false))
          }, null, 8 /* PROPS */, ["default-value", "suggestions", "process", "classes"])
        ]),
        ($setup.isFastDelivery)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              ($setup.processCheckingAddress)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[4] || (_cache[4] = [
                    _createElementVNode("div", { class: "status-icon" }, [
                      _createElementVNode("span", { class: "spinner" })
                    ], -1 /* HOISTED */),
                    _createElementVNode("div", { class: "status-text" }, " Проверяем возможность доставки... ", -1 /* HOISTED */)
                  ])))
                : (
                                $setup.availableDeliveryStatus !==
                                $setup.DeliveryStatus.UNKNOWN
                            )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass([
                                'status-block',
                                $setup.availableDeliveryStatus ===
                                    $setup.DeliveryStatus.AVAILABLE &&
                                !!$setup.props.defaultStore
                                    ? 'status-block--success'
                                    : 'status-block--warning',
                            ])
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", {
                          class: _normalizeClass($setup.availableDeliveryIcon)
                        }, null, 2 /* CLASS */)
                      ]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString($setup.availableDeliveryText), 1 /* TEXT */)
                    ], 2 /* CLASS */))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "status-icon" }, [
                        _createElementVNode("span", { class: "info" })
                      ], -1 /* HOISTED */)),
                      _createElementVNode("div", _hoisted_9, _toDisplayString($setup.validationMessage), 1 /* TEXT */)
                    ]))
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              ($setup.house && !$setup.canProceed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "status-icon" }, [
                      _createElementVNode("span", { class: "info" })
                    ], -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_11, _toDisplayString($setup.validationMessage), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */)),
        ($setup.address.value && $setup.house)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode($setup["ValidatedInput"], {
                label: "",
                type: "text",
                placeholder: "Введите квартиру/офис",
                "handle-validation-type": "input",
                required: false,
                value: $setup.appart,
                "external-valid": !!$setup.appart,
                onHandleInput: _cache[3] || (_cache[3] = (val) => ($setup.appart = val)),
                onHandleBlur: $setup.setConfirmedApartment
              }, null, 8 /* PROPS */, ["value", "external-valid"])
            ]))
          : _createCommentVNode("v-if", true),
        (
                        $setup.isFastDelivery &&
                        !$setup.processCheckingAddress &&
                        $setup.availableDeliveryStatus === $setup.DeliveryStatus.AVAILABLE
                    )
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              ($props.realPrice && $props.realDeliveryText)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "delivery-info__label" }, "Стоимость доставки:", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_16, _toDisplayString($props.realPrice) + " ₽", 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "delivery-info__label" }, "Плановое время доставки:", -1 /* HOISTED */)),
                      _createElementVNode("span", _hoisted_18, _toDisplayString($props.detailedDeliveryTimes || $props.realDeliveryText), 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.nearestStore)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "store-info__title" }, " Доставка будет осуществлена из магазина: ", -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_20, _toDisplayString($setup.nearestStore), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.isFastDelivery && $props.externalCheckingStores)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[10] || (_cache[10] = [
              _createElementVNode("div", { class: "status-block status-block--checking" }, [
                _createElementVNode("div", { class: "status-icon" }, [
                  _createElementVNode("span", { class: "spinner" })
                ]),
                _createElementVNode("div", { class: "status-text" }, " Проверяем возможность доставки... ")
              ], -1 /* HOISTED */)
            ])))
          : _createCommentVNode("v-if", true),
        ($setup.address.value && $setup.house)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn", [
                            $setup.isChecking ||
                            !$setup.canProceed ||
                            (!$setup.isFastDelivery && !$setup.coordinates.lat)
                                ? 'btn-secondary'
                                : 'btn-warning',
                        ]]),
                disabled: 
                            $setup.isChecking ||
                            !$setup.canProceed ||
                            (!$setup.isFastDelivery &&
                                (!$setup.coordinates.lat || !$setup.coordinates.lng))
                        ,
                onClick: $setup.onContinueClick
              }, " Продолжить ", 10 /* CLASS, PROPS */, _hoisted_23),
              ($setup.isFastDelivery && !$setup.canProceed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Укажите номер квартиры или офиса "))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode($setup["YandexMap"], {
        settings: $setup.settings,
        options: $setup.options,
        coordinates: $setup.mapCenter,
        zoom: $setup.mapZoom,
        controls: $setup.controls,
        "detailed-controls": $setup.detailedControls,
        onCreated: $setup.onMapCreated,
        onClick: $setup.onMapClick
      }, {
        default: _withCtx(() => [
          ($setup.markerCoords)
            ? (_openBlock(), _createBlock($setup["YandexMarker"], {
                key: 0,
                "marker-id": "address-clarification",
                coordinates: $setup.markerCoords,
                options: $setup.markerOptions
              }, null, 8 /* PROPS */, ["coordinates"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["settings", "options", "coordinates", "zoom", "controls", "detailed-controls"])
    ])
  ], 2 /* CLASS */))
}